import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{staticClass:"section-count-item",attrs:{"no-gutters":""}},[_c(VCol,{staticClass:"text-right"},[_c('div',{staticClass:"count-number gradient-text"},[_vm._v(_vm._s(_vm.count))])]),_c(VCol,{staticClass:"d-flex align-center"},[_c('h4',{staticClass:"count-text"},[_c('span',[_vm._v(_vm._s(_vm.text1))]),_c('span',[_vm._v(_vm._s(_vm.text2))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }